import React from "react";
import { Route, Switch } from "react-router-dom";
import Produto from "./Produto";
import Lista from "./Lista";

const Index = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      {/* <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} /> */}
      <Route exact path={`${match.url}/`} component={Lista} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/:id`} component={Produto} />
    </Switch>
  </div>
);

export default Index;
